export default () => ({
    mapContainer: null,
    options: {
        root: null,
        rootMargin: '0px 0px 200px 0px',
        threshold: 0
    },
    init() {
        this.mapContainer = this.$el;
        const io = new IntersectionObserver(function (entries, observer) {
            const entry = entries[0];
            if (entry.isIntersecting) {
                Promise.all([
                    import('mapbox-gl/dist/mapbox-gl.css'),
                    import('mapbox-gl')
                ]).then(([, mapboxglModule]) => {
                    const mapboxgl = mapboxglModule.default ?? mapboxglModule;

                    const map = new mapboxgl.Map({
                        accessToken: 'pk.eyJ1IjoiaG9tZXBhZ2VoZWxkZW4iLCJhIjoiY2xrdG4xOW1iMGJ6NDNkcHBwZHFvMnpsaiJ9.3Kz4QO2iVG17UUCokrlRHA',
                        container: 'map',
                        style: 'mapbox://styles/hph/clgzh4wfi00i901pnfb2p9pmb',
                        center: [10.0183432948567, 51.1334813439932],
                        zoom: 4,
                        maxZoom: 6,
                        minZoom: 3
                    });

                    map.addControl(new mapboxgl.NavigationControl());
                    map.scrollZoom.disable();

                    map.on('load', function () {
                        const coordinates = [
                            [10.0151198, 53.5730684],
                            [13.5779228, 51.130518],
                            [6.9370026, 50.9435762],
                            [9.913065, 53.581417],
                            [10.0553744, 53.5885838],
                            [9.9852574, 53.5316484],
                            [10.8942662, 48.3656729],
                            [11.5605837, 52.2118946],
                            [13.4607296, 48.5718453],
                            [8.8370062, 47.2308924],
                            [10.0929911, 53.517068],
                            [10.0975466, 53.6917119],
                            [8.0937324, 51.5627312],
                            [9.9690496, 53.564431],
                            [9.9118726, 53.5678526],
                            [9.9496132, 53.6290042],
                            [10.0475077, 53.5673806],
                            [8.2400017, 50.0760976],
                            [10.009959, 53.6088274],
                            [10.5214314, 52.2630024],
                            [8.7736533, 50.2303566],
                            [6.7722474, 51.1997752],
                            [9.9807553, 53.5552494],
                            [10.1204336, 53.6514412],
                            [10.0017259, 53.5507515],
                            [9.9936835, 53.5596267],
                            [9.8592201, 53.6405776],
                            [9.8086195, 52.3082442],
                            [10.7089304, 53.8301518],
                            [7.2553745, 49.3560225],
                            [10.0117748, 53.7263514],
                            [8.2475134, 50.0982399],
                            [9.923999, 53.7589783],
                            [9.9690496, 53.564431],
                            [9.9118726, 53.5678526],
                            [7.8374651, 48.0044582],
                            [9.8545484, 53.5862877],
                            [10.0151198, 53.5730684],
                            [8.8300606, 50.4169669],
                            [11.5534509, 48.2000526],
                            [9.8776657, 53.598033],
                            [13.2107326, 52.4675293],
                            [10.1699453, 53.5422138],
                            [8.5981533, 47.4166223],
                            [14.3171502, 48.2968472],
                            [9.9153055, 53.5566366],
                            [8.69492, 50.0295097],
                            [13.3847539, 52.5155098],
                            [13.5128582, 52.4382805],
                            [10.0808254, 53.6414254],
                            [6.9538847, 50.9386437],
                            [6.9538847, 50.9386437],
                            [6.9538847, 50.9386437],
                            [6.9538847, 50.9386437],
                            [9.913065, 53.581417],
                            [9.9229728, 52.1676714],
                            [9.9936835, 53.5596267],
                            [7.1417099, 51.2623662],
                            [9.963475, 51.5665532],
                            [7.0079155, 58.3857679],
                            [9.8086195, 52.3082442],
                            [9.9852574, 53.5316484],
                            [9.4260898, 53.7911914],
                            [10.0656041, 53.6670472],
                            [9.9852574, 53.5316484],
                            [9.9153055, 53.5566366],
                            [8.5422655, 47.423286],
                            [6.7774607, 50.7948075],
                            [8.311244, 54.886578],
                            [10.3822557, 53.8076269],
                            [10.0017259, 53.5507515],
                            [10.0807485, 53.5754959],
                            [13.4761485, 52.5593051],
                            [8.6063932, 49.8483442],
                            [10.0061481, 53.5831749],
                            [8.8611632, 53.1013476],
                            [9.7964715, 53.5610383],
                            [9.4594184, 48.6425125],
                            [10.6180751, 53.9317319],
                            [8.2400017, 50.0760976],
                            [9.9852574, 53.5316484],
                            [9.9641638, 52.8092281],
                            [9.9641759, 53.5511779],
                            [8.5829894, 49.7933991],
                            [9.6554, 46.7772287],
                            [9.9852574, 53.5316484],
                            [6.7920994, 50.9089383],
                            [6.7920994, 50.9089383],
                            [8.209163, 48.7995549],
                            [7.8519788, 47.9685863],
                            [8.4465631, 47.3983398],
                            [10.244846, 53.6097988],
                            [9.9852574, 53.5316484],
                            [10.118565, 53.6160317],
                            [10.0808254, 53.6414254],
                            [7.4365122, 51.5270219],
                            [10.0176987, 53.548038],
                            [10.0383761, 53.6447228],
                            [10.0151198, 53.5730684],
                            [9.9690496, 53.564431],
                            [10.3153293, 53.5252333],
                            [8.529471, 47.340415],
                            [14.2127612, 50.7725563],
                            [8.2430405, 47.3830192],
                            [9.9563647, 53.5709612],
                            [9.6828348, 53.4639095],
                            [7.1466066, 51.2554934],
                            [6.9538998, 50.9320995],
                            [13.528007, 52.4609452],
                            [6.7190874, 51.233068],
                            [9.9936835, 53.5596267],
                            [13.3803558, 54.0777776],
                            [10.0017259, 53.5507515],
                            [7.9454618, 50.0247217],
                            [8.300862, 50.1652984],
                            [10.0559167, 53.6104136],
                            [11.585399, 48.1865394],
                            [9.5002, 48.0147205],
                            [9.9908875, 53.5776266],
                            [10.1759457, 53.5715488],
                            [10.2034802, 52.4648432],
                            [11.1859374, 55.6712271],
                            [9.9871703, 53.5488282],
                            [10.0294627, 53.5798405],
                            [7.7047379, 49.2177945],
                            [7.9844554, 50.8803723],
                            [10.0408127, 53.7841814],
                            [10.1759457, 53.5715488],
                            [7.0822261, 50.881777],
                            [9.9871703, 53.5488282],
                            [10.0975466, 53.6917119],
                            [9.9778279, 53.5472987],
                            [9.7492444, 52.2466018],
                            [10.0383761, 53.6447228],
                            [13.0751666, 52.5696551],
                            [10.0017259, 53.5507515],
                            [10.0002195, 53.6643583],
                            [9.9819779, 53.5688101],
                            [6.0404099, 50.7779566],
                            [10.0103641, 53.6486665],
                            [7.8115101, 48.021186],
                            [7.7857931, 48.0054911],
                            [9.6193117, 53.9683771],
                            [13.4093313, 52.5221879],
                            [11.5695525, 48.1440989],
                            [10.0839485, 53.736687],
                            [10.7710605, 53.6989627],
                            [7.1648955, 50.7454941],
                            [10.5665003, 52.2346447],
                            [10.2260726, 53.489276],
                            [11.7187275, 49.1603469],
                            [9.9690496, 53.564431],
                            [10.15612, 48.3037462],
                            [10.0176987, 53.548038],
                            [10.5814706, 52.2764013],
                            [10.5814706, 52.2764013],
                            [9.9999424, 53.59451],
                            [7.3013584, 50.940947],
                            [9.3729147, 53.8937194],
                            [7.8998109, 51.5548237],
                            [9.8694845, 53.3176971],
                            [9.2879696, 53.8238816],
                            [9.9852574, 53.5316484],
                            [9.9426073, 53.5488885],
                            [7.6872678, 47.9125658],
                            [9.7184337, 53.6977863],
                            [6.9110268, 50.9516638],
                            [10.1693369, 53.5898122],
                            [9.9936835, 53.5596267],
                            [9.9936835, 53.5596267],
                            [7.7751002, 51.9878803],
                            [9.9778279, 53.5472987],
                            [13.3429021, 52.4972347],
                            [13.3429021, 52.4972347],
                            [11.5286651, 48.0966922],
                            [9.4051553, 54.7675063],
                            [10.0383761, 53.6447228],
                            [10.0383761, 53.6447228],
                            [10.9163473, 53.5487491],
                            [9.8826238, 53.570291],
                            [8.4327982, 49.9901899],
                            [11.5018723, 48.1597717],
                            [11.5018723, 48.1597717],
                            [8.9022967, 49.4848039],
                            [13.3246134, 52.4993282],
                            [9.9936835, 53.5596267],
                            [10.2167335, 53.5447292],
                            [9.8954232, 53.6156915],
                            [6.5442659, 51.2654601],
                            [8.8778703, 53.1190688],
                            [9.9908875, 53.5776266],
                            [10.4028748, 53.6111512],
                            [13.343094, 52.5094286],
                            [10.569299, 51.9610743],
                            [9.9438616, 53.5754253],
                            [13.2355484, 52.5026955],
                            [10.1645331, 53.6476751],
                            [9.8592201, 53.6405776],
                            [9.9426073, 53.5488885],
                            [7.4290444, 49.2498875],
                            [8.6805821, 50.1153944],
                            [11.5105593, 48.1488271],
                            [11.6271017, 53.2778302],
                            [9.9819779, 53.5688101],
                            [9.9118726, 53.5678526],
                            [7.1221114, 50.7194159],
                            [6.7635076, 51.512382],
                            [9.2759206, 48.4757988],
                            [8.7235821, 47.308497],
                            [9.5661514, 54.5223028],
                            [10.9688254, 54.1864923],
                            [7.4335036, 53.1371972],
                            [9.9966164, 53.5675782],
                            [8.2361563, 50.0017921],
                            [13.83256, 54.11394],
                            [7.6198121, 47.5934368],
                            [10.0058214, 53.6283203],
                            [13.404954, 52.5200066],
                            [10.0857012, 54.3328226],
                            [7.7524728, 49.9661051],
                            [9.9852574, 53.5316484],
                            [7.2118403, 50.8000454],
                            [10.048934, 53.550862],
                            [9.4901695, 53.8368108],
                            [9.182863, 48.7827027],
                            [12.0217853, 54.0404886],
                            [9.9936835, 53.5596267],
                            [9.9118726, 53.5678526],
                            [13.5779228, 51.130518],
                            [13.4093313, 52.5221879],
                            [6.8851369, 50.9401086],
                            [9.9852574, 53.5316484],
                            [13.3650508, 52.5069115],
                            [13.3650508, 52.5069115],
                            [8.4696704, 50.0842199],
                            [13.4230065, 52.5341936],
                            [9.9999424, 53.59451],
                            [10.0017259, 53.5507515],
                            [9.9819779, 53.5688101],
                            [10.2353838, 53.6744402],
                            [10.0017259, 53.5507515],
                            [13.3777035, 52.532614],
                            [10.048934, 53.550862],
                            [9.9936835, 53.5596267],
                            [13.6381138, 54.3931323],
                            [9.8514063, 53.515527],
                            [9.8086195, 52.3082442],
                            [9.6828348, 53.4639095],
                            [13.177061, 52.0818855],
                            [9.6257974, 53.408572],
                            [12.0662928, 54.1522067],
                            [3.3783644, 39.6043024],
                            [10.0017259, 53.5507515],
                            [10.118565, 53.6160317],
                            [9.9588669, 53.6650949],
                            [10.9163473, 53.5487491],
                            [9.9936835, 53.5596267],
                            [9.8776657, 53.598033],
                            [9.731293, 52.4323268],
                            [10.1260105, 53.5853131],
                            [11.6417995, 48.1567438],
                            [9.8826238, 53.570291],
                            [10.0151198, 53.5730684],
                            [7.6682681, 52.4162209],
                            [7.6682681, 52.4162209],
                            [10.1645331, 53.6476751],
                            [0.0290104, 51.1231469],
                            [9.9852574, 53.5316484],
                            [9.9852574, 53.5316484],
                            [8.5314882, 47.15583],
                            [8.2312588, 46.8500287],
                            [13.414046, 52.5121401],
                            [9.3882401, 54.7459084],
                            [9.9659855, 53.6125259],
                            [10.0017259, 53.5507515],
                            [7.4198285, 51.4646773],
                            [11.490008, 48.1307794],
                            [7.1895576, 51.6164977],
                            [10.0017259, 53.5507515],
                            [10.6139151, 54.1319978],
                            [8.8107219, 50.0809432],
                            [10.0017259, 53.5507515],
                            [11.7199081, 47.7166716],
                            [13.3352069, 52.4736908],
                            [8.6752346, 50.1248611],
                            [9.8291495, 53.5993247],
                            [6.8693678, 50.9829287],
                            [8.7073854, 53.8552071],
                            [10.048934, 53.550862],
                            [9.9852574, 53.5316484],
                            [9.9690496, 53.564431],
                            [8.4478809, 53.4927518],
                            [10.0986376, 53.588951],
                            [9.5192039, 53.9366967],
                            [9.052606, 48.4936788],
                            [10.114134, 53.553521],
                            [9.7964715, 53.5610383],
                            [9.9588669, 53.6650949],
                            [9.8001421, 48.6391303],
                            [10.2396789, 54.2836278],
                            [10.0408127, 53.7841814],
                            [10.1759457, 53.5715488],
                            [10.1260105, 53.5853131],
                            [7.963965, 48.829742],
                            [6.9137713, 50.9096296],
                            [9.9778279, 53.5472987],
                            [10.2656004, 53.7287773],
                            [10.2099094, 53.9528496],
                            [9.9778279, 53.5472987],
                            [10.0002195, 53.6643583],
                            [9.9778279, 53.5472987],
                            [9.930842, 53.5990653],
                            [10.0475077, 53.5673806],
                            [12.1666436, 54.0838949],
                            [9.9966164, 53.5675782],
                            [10.3611665, 53.4379562],
                            [9.929928, 53.5554142],
                            [9.5617735, 50.9028644],
                            [7.0828745, 51.201055],
                            [10.0471829, 49.6543304],
                            [9.9852574, 53.5316484],
                            [8.7909406, 53.0915236],
                            [10.5793453, 52.3088545],
                            [6.8091727, 51.2357381],
                            [10.7089304, 53.8301518],
                            [9.7737388, 52.3358144],
                            [9.9666072, 53.5783009],
                            [13.3650508, 52.5069115],
                            [9.8694845, 53.3176971],
                            [9.6429685, 54.3063359],
                            [9.9852574, 53.5316484],
                            [6.4910825, 51.1619037],
                            [8.4897373, 50.1567676],
                            [10.0438337, 54.2836577],
                            [9.9999424, 53.59451],
                            [10.0408127, 53.7841814],
                            [9.958595, 53.8306132],
                            [10.0475077, 53.5673806],
                            [10.1260105, 53.5853131],
                            [9.9852574, 53.5316484],
                            [9.9871703, 53.5488282],
                            [11.5192416, 48.1378841],
                            [-0.93519, 45.305814],
                            [13.3253773, 52.4693894],
                            [6.9240043, 50.9508935],
                            [10.0017259, 53.5507515],
                            [9.1557429, 49.9117009],
                            [7.0563538, 50.8095768],
                            [13.2706899, 52.5747293],
                            [9.982105, 53.5947669],
                            [8.5750137, 48.8994595],
                            [8.5267528, 47.2003879],
                            [9.182863, 48.7827027],
                            [9.182863, 48.7827027],
                            [9.9659855, 53.6125259],
                            [10.0102206, 48.3735527],
                            [10.0102206, 48.3735527],
                            [10.43319, 53.67617],
                            [9.9966164, 53.5675782],
                            [10.0807485, 53.5754959],
                            [10.7496052, 53.8024753],
                            [6.9370026, 50.9435762],
                            [9.9953344, 53.6921392],
                            [11.9261371, 53.1168791],
                            [9.9659855, 53.6125259],
                            [7.6142282, 51.9425363],
                            [9.8222167, 53.6217669],
                            [10.2782723, 54.232759],
                            [10.048934, 53.550862],
                            [10.0383761, 53.6447228],
                            [10.8942662, 48.3656729],
                            [10.0176987, 53.548038],
                            [10.2519749, 53.4911236],
                            [9.7964715, 53.5610383],
                            [10.0002195, 53.6643583],
                            [9.929928, 53.5554142],
                            [6.7722474, 51.1997752],
                            [8.5520555, 50.2091998],
                            [9.9807553, 53.5552494],
                            [9.886819, 53.5508168],
                            [8.9534183, 53.2381881],
                            [10.0058214, 53.6283203],
                            [9.4212794, 54.8022869],
                            [8.4230994, 49.5020732],
                            [10.0176987, 53.548038],
                            [9.913065, 53.581417],
                            [31.2357116, 30.0444196],
                            [8.4475019, 48.0564208],
                            [4.3943477, 50.8335737],
                            [9.9118726, 53.5678526],
                            [9.9778279, 53.5472987],
                            [13.7964562, 51.0374106],
                            [6.9512663, 51.1191898],
                            [9.9852574, 53.5316484],
                            [9.9426073, 53.5488885],
                            [11.116667, 53.766667],
                            [9.9581828, 53.5913082],
                            [8.5572261, 47.4122963],
                            [9.9966164, 53.5675782],
                            [10.167967, 53.6063399],
                            [10.2167335, 53.5447292],
                            [10.1699453, 53.5422138],
                            [10.0151198, 53.5730684],
                            [10.6990778, 53.6116343],
                            [7.2714747, 51.5162564],
                            [10.4509972, 53.4415545],
                            [10.1693369, 53.5898122],
                            [8.5439931, 47.3886229],
                            [8.5501985, 49.8576781],
                            [13.1828063, 52.6855564],
                            [9.9217286, 53.646315],
                            [11.3848384, 50.4872937],
                            [10.0058214, 53.6283203],
                            [9.3824058, 54.6584899],
                            [10.0017259, 53.5507515],
                            [11.7166205, 47.8315569],
                            [7.8205932, 48.0430053],
                            [10.048934, 53.550862],
                            [12.5926233, 51.8669396],
                            [10.2260726, 53.489276],
                            [10.0383761, 53.6447228],
                            [9.6502987, 49.4723473],
                            [7.7357128, 51.9212884],
                            [8.1976788, 50.1053491],
                            [6.2636408, 50.8235705],
                            [11.0043771, 49.5613968],
                            [11.0043771, 49.5613968],
                            [8.4601345, 50.1900341],
                            [11.6875629, 48.1383204],
                            [11.630583, 48.2398824],
                            [10.0017259, 53.5507515],
                            [10.0176987, 53.548038],
                            [10.2730016, 53.651326],
                            [13.4411785, 52.5239492],
                            [6.7790167, 51.248009],
                            [8.4327982, 49.9901899],
                            [8.217699, 47.4767224],
                            [13.3847539, 52.5155098],
                            [9.9999424, 53.59451],
                            [9.9002791, 53.4023217],
                            [10.048934, 53.550862],
                            [7.6118814, 50.3101356],
                            [6.9538998, 50.9320995],
                            [9.9999424, 53.59451],
                            [8.6935081, 49.3693394],
                            [9.9641759, 53.5511779],
                            [9.905541, 53.6639774],
                            [9.7964715, 53.5610383],
                            [11.5695525, 48.1440989],
                            [10.5814706, 52.2764013],
                            [8.3307559, 47.6242998],
                            [10.0117748, 53.7263514],
                            [9.982105, 53.5947669],
                            [10.0017259, 53.5507515],
                            [8.0257971, 53.6307029],
                            [10.2903405, 47.5740689],
                            [10.1645331, 53.6476751],
                            [7.0359393, 50.379938],
                            [8.4626853, 47.2437564],
                            [10.0017259, 53.5507515],
                            [8.4626853, 47.2437564],
                            [10.0061481, 53.5831749],
                            [10.2260726, 53.489276],
                            [11.3364793, 48.7557151],
                            [10.9163473, 53.5487491],
                            [8.1500317, 48.6824642],
                            [10.9245621, 48.3930563],
                            [5.3045198, 52.1819723],
                            [12.9276162, 52.2286552],
                            [9.982105, 53.5947669],
                            [9.9936835, 53.5596267],
                            [10.1315442, 54.323924],
                            [7.1847865, 51.7810293],
                            [9.9426073, 53.5488885],
                            [10.0852568, 53.607925],
                            [8.6591469, 50.1157078],
                            [9.974511, 53.7075768],
                            [10.7089304, 53.8301518],
                            [11.5101041, 48.0834915],
                            [10.0498354, 53.624604],
                            [9.74379, 47.4124],
                            [10.8553557, 48.3920947],
                            [13.2107326, 52.4675293],
                            [13.3015288, 52.5073952],
                            [9.9852574, 53.5316484],
                            [6.8769987, 50.9984287],
                            [12.9525423, 51.5486301],
                            [9.1289499, 48.7790996],
                            [1.4284951, 38.7054465],
                            [13.4682234, 51.4843146],
                            [9.2094818, 48.6628873],
                            [11.3965968, 48.1678509],
                            [10.0058214, 53.6283203],
                            [9.91816, 53.69154],
                            [8.8606613, 52.9092262],
                            [8.6428547, 50.1272873],
                            [7.2263052, 51.5111295],
                            [10.4090787, 51.9968733],
                            [10.3850525, 53.7067104],
                            [10.0083967, 52.4827623],
                            [11.3231808, 48.1686992],
                            [9.8222167, 53.6217669],
                            [9.982105, 53.5947669],
                            [10.0839485, 53.736687],
                            [7.5468477, 51.9601912],
                            [10.0103641, 53.6486665],
                            [10.0808254, 53.6414254],
                            [7.6378543, 51.9782559],
                            [9.1789875, 48.1019488],
                            [8.5246804, 52.005081],
                            [11.2765606, 48.8246316],
                            [10.2353306, 53.7950201],
                            [10.0103641, 53.6486665],
                            [10.009959, 53.6088274],
                            [7.0381829, 51.4592319],
                            [10.2857632, 53.8647107],
                            [10.0260615, 53.5910631],
                            [10.0061481, 53.5831749],
                            [9.8694845, 53.3176971],
                            [10.2332027, 50.0565964],
                            [9.4901695, 53.8368108],
                            [10.2443392, 53.5170003],
                            [9.9999424, 53.59451],
                            [10.2730016, 53.651326],
                            [9.8464909, 53.254285],
                            [10.0417788, 53.5987643],
                            [11.7631748, 48.3827885],
                            [13.484745, 52.4985439],
                            [9.9666072, 53.5783009],
                            [9.6531604, 48.7098377],
                            [8.4327982, 49.9901899],
                            [9.9426073, 53.5488885],
                            [13.0072677, 54.2934673],
                            [9.9519685, 53.5795289],
                            [9.74379, 47.4124],
                            [9.7306457, 53.3598239],
                            [10.5567652, 51.9520394],
                            [7.8796643, 52.445152],
                            [10.0260615, 53.5910631],
                            [10.0260615, 53.5910631],
                            [9.9819779, 53.5688101],
                            [9.929928, 53.5554142],
                            [13.2569144, 52.2780825],
                            [8.9485562, 50.0341081],
                            [6.7190874, 51.233068],
                            [9.9496132, 53.6290042],
                            [11.925775, 48.3102529],
                            [9.8826238, 53.570291],
                            [8.5679249, 47.3671055],
                            [10.5599436, 53.473305],
                            [7.8868064, 48.4590556],
                            [9.8291495, 53.5993247],
                            [8.564478, 50.2497872],
                            [6.0958906, 50.7959332],
                            [10.0017259, 53.5507515],
                            [9.9426073, 53.5488885],
                            [9.9953344, 53.6921392],
                            [8.0205892, 53.1856017],
                            [9.886819, 53.5508168],
                            [10.0058214, 53.6283203],
                            [8.4095757, 49.0487963],
                            [13.0665558, 52.3997691],
                            [10.6035943, 52.7282038],
                            [9.9819779, 53.5688101],
                            [10.2206985, 53.6154895],
                            [13.1885029, 52.2317821],
                            [9.9147496, 53.7897799],
                            [10.7849537, 53.713598],
                            [9.4637422, 53.5852809],
                            [9.9548938, 52.1462043],
                            [8.69492, 50.0295097],
                            [8.7619712, 49.8624196],
                            [8.9277404, 53.0725631],
                            [13.2669471, 52.6621485],
                            [8.8341612, 52.9450038],
                            [7.4719968, 50.3146513],
                            [8.9029165, 48.641586],
                            [10.0077385, 53.8090449],
                            [10.1645331, 53.6476751],
                            [7.972033, 51.4522286],
                            [9.1068193, 49.350141],
                            [10.0309596, 54.1762237],
                            [9.9852574, 53.5316484],
                            [9.8995154, 53.7302729],
                            [8.6738623, 50.0990675],
                            [12.5926233, 51.8669396],
                            [10.0660501, 54.2646986],
                            [9.7178209, 53.7507302],
                            [10.1645331, 53.6476751],
                            [9.8111839, 53.688881],
                            [13.3786773, 52.5504704],
                            [9.7424371, 53.659615],
                            [8.4588361, 54.7003766],
                            [10.0151198, 53.5730684],
                            [2.6760251, 39.5617364],
                            [7.9304875, 52.3138428],
                            [9.3603629, 50.8772747],
                            [10.1283722, 53.6726615],
                            [7.9744954, 48.5476784],
                            [11.4347172, 47.6054173],
                            [10.2625077, 53.7635437],
                            [10.2625077, 53.7635437],
                            [10.0117748, 53.7263514],
                            [9.929928, 53.5554142],
                            [9.8222167, 53.6217669],
                            [10.0056525, 53.4643986],
                            [8.4602772, 51.977755],
                            [10.4456941, 52.3423663],
                            [10.3924227, 53.2130077],
                            [55.3060551, 25.2230543],
                            [9.9936835, 53.5596267],
                            [9.9852574, 53.5316484],
                            [10.1606432, 51.5868827],
                            [13.0490488, 53.1020087],
                            [7.1920572, 51.5740255],
                            [10.0559167, 53.6104136],
                            [10.0986376, 53.588951],
                            [10.2353838, 53.6744402],
                            [10.3197231, 53.6561885],
                            [9.8995154, 53.7302729],
                            [17.1194923, 48.1483472],
                            [11.572893, 48.1362105],
                            [9.6818952, 53.8555533],
                            [9.9471012, 53.5662722],
                            [9.982105, 53.5947669],
                            [9.7536133, 52.3656943],
                            [11.572893, 48.1362105],
                            [9.7295909, 47.4987263],
                            [7.5836067, 48.0348382],
                            [11.3965968, 48.1678509],
                            [10.7406857, 53.8712446],
                            [9.9471012, 53.5662722],
                            [9.56155, 46.9009],
                            [6.8091727, 51.2357381],
                            [10.0975466, 53.6917119],
                            [12.8416644, 47.7273236],
                            [7.5837039, 51.8939868],
                            [9.473265, 54.7843482],
                            [10.0056525, 53.4643986],
                            [7.0042465, 51.2057991],
                            [10.3486912, 53.6946674],
                            [9.982105, 53.5947669],
                            [7.652434, 47.582659],
                            [10.6183077, 47.779563],
                            [10.2730016, 53.651326],
                            [9.9871703, 53.5488282],
                            [6.6138604, 51.4866216],
                            [7.5734973, 51.2596963],
                            [10.2206985, 53.6154895],
                            [9.9852574, 53.5316484],
                            [10.0553744, 53.5885838],
                            [13.3380778, 52.5011803],
                            [10.0117748, 53.7263514],
                            [9.8592201, 53.6405776],
                            [11.0436405, 53.1479724],
                            [9.9852574, 53.5316484],
                            [7.0042465, 51.2057991],
                            [10.2656004, 53.7287773],
                            [9.6828348, 53.4639095],
                            [9.9690496, 53.564431],
                            [10.0437551, 53.5267106],
                            [10.1283722, 53.6726615],
                            [9.9936835, 53.5596267],
                            [10.0383761, 53.6447228],
                            [10.0151198, 53.5730684],
                            [9.9153055, 53.5566366],
                            [7.4694954, 51.3981699],
                            [9.9496132, 53.6290042],
                            [9.9659855, 53.6125259],
                            [9.9659855, 53.6125259],
                            [9.4565908, 53.6076994],
                            [9.9002791, 53.4023217],
                            [10.244846, 53.6097988],
                            [10.0176987, 53.548038],
                            [9.9852574, 53.5316484],
                            [9.9581828, 53.5913082],
                            [9.9936835, 53.5596267],
                            [10.2260726, 53.489276],
                            [9.9908875, 53.5776266],
                            [12.0759335, 54.1023972],
                            [9.0827095, 53.2587147],
                            [9.6285342, 51.8824786],
                            [9.7055678, 53.5275423],
                            [10.114134, 53.553521],
                            [10.1154383, 54.3943283],
                            [9.9908875, 53.5776266],
                            [10.0061481, 53.5831749],
                            [10.6239283, 53.2670138],
                            [9.9496132, 53.6290042],
                            [10.0553744, 53.5885838],
                            [9.9217286, 53.646315],
                            [9.9118726, 53.5678526],
                            [7.7099696, 52.2750008],
                            [10.0319897, 53.4949324],
                            [9.6763338, 53.6872441],
                            [7.7178464, 49.8152836],
                            [10.8819032, 49.5782416],
                            [7.8669573, 48.0423901],
                            [9.7156831, 52.3863062],
                            [10.1007586, 53.5683271],
                            [6.7727077, 51.2220859],
                            [9.9581828, 53.5913082],
                            [8.3742517, 49.209194],
                            [12.39006, 51.3616353],
                            [13.43856, 52.5147455],
                            [10.0852568, 53.607925],
                            [9.8338808, 53.6509015],
                            [9.6763338, 53.6872441],
                            [7.0110011, 50.9561644],
                            [7.9322363, 53.2782834],
                            [13.2669471, 52.6621485],
                            [10.114134, 53.553521],
                            [10.65, 53.716667],
                            [13.2005562, 52.4307217],
                            [13.2885484, 52.4532523],
                            [10.6239283, 53.2670138],
                            [10.0807485, 53.5754959],
                            [14.3373837, 51.7346666],
                            [10.1007586, 53.5683271],
                            [9.8826238, 53.570291],
                            [9.9766112, 53.5747274],
                            [9.8694845, 53.3176971],
                            [9.603088, 53.5600087],
                            [10.0056525, 53.4643986],
                            [10.6221291, 49.0945444],
                            [6.602028, 51.2134619],
                            [9.982105, 53.5947669],
                            [10.0475077, 53.5673806],
                            [10.0808254, 53.6414254],
                            [10.0808254, 53.6414254],
                            [10.1283722, 53.6726615],
                            [9.7964715, 53.5610383],
                            [10.3035862, 53.9332035],
                            [10.1260105, 53.5853131],
                            [9.9288308, 53.4599405],
                            [9.8592201, 53.6405776],
                            [13.2669471, 52.6621485],
                            [8.7823611, 50.0856921],
                            [9.929928, 53.5554142],
                            [11.5757012, 48.1510227],
                            [10.3924227, 53.2130077],
                            [8.5933513, 49.1064222],
                            [9.6800016, 54.3178434],
                            [9.8826238, 53.570291],
                            [12.2159732, 53.8000621],
                            [10.1313254, 54.427125],
                            [10.0151198, 53.5730684],
                            [9.9641759, 53.5511779],
                            [9.9897946, 53.5900195],
                            [9.9666072, 53.5783009],
                            [9.886819, 53.5508168],
                            [11.8277849, 51.1050239],
                            [9.929928, 53.5554142],
                            [9.9426073, 53.5488885],
                            [11.5361212, 53.7378563],
                            [10.1645331, 53.6476751],
                            [10.1693369, 53.5898122],
                            [9.8995154, 53.7302729],
                            [7.4273286, 46.9588575],
                            [10.199618, 53.5058423],
                            [10.199618, 53.5058423],
                            [8.6142087, 50.2279312],
                            [10.0235779, 53.5639378],
                            [9.9147496, 53.7897799],
                            [9.9666072, 53.5783009],
                            [10.7503478, 53.8014688],
                            [10.0017259, 53.5507515],
                            [10.0017259, 53.5507515],
                            [9.9364015, 49.9842803],
                            [10.0731388, 52.2621392],
                            [9.8954232, 53.6156915],
                            [14.0735499, 52.5680243],
                            [13.2669471, 52.6621485],
                            [8.4173066, 48.9999533],
                            [10.048934, 53.550862],
                            [9.8954232, 53.6156915],
                            [10.1260105, 53.5853131],
                            [13.0380686, 47.8051393],
                            [9.7537598, 53.5830905],
                            [8.4183208, 49.4537628],
                            [10.0017259, 53.5507515],
                            [10.0061481, 53.5831749],
                            [9.5453959, 48.8856722],
                            [12.117951, 49.1293396],
                            [11.3390089, 47.9999615],
                            [10.1426546, 53.52988],
                            [8.5482855, 52.0066434],
                            [9.052606, 48.4936788],
                            [10.0260615, 53.5910631],
                            [13.8339, 51.0229541],
                            [10.1204336, 53.6514412],
                            [13.4072944, 52.5455109],
                            [10.0103641, 53.6486665],
                            [9.4803861, 51.3021767],
                            [9.9153055, 53.5566366],
                            [8.4475019, 48.0564208],
                            [10.0260615, 53.5910631],
                            [13.6377661, 52.5468595],
                            [7.0402385, 51.1843821],
                            [9.9735576, 53.4998604],
                            [10.6357577, 53.8202452],
                            [10.0656041, 53.6670472],
                            [1.2934954, 38.9217535],
                            [7.4104258, 53.0521313],
                            [9.8954232, 53.6156915],
                            [8.9402185, 52.2253083],
                            [9.74051, 52.4460851],
                            [10.0017259, 53.5507515],
                            [9.9581828, 53.5913082],
                            [10.1952121, 53.6888482],
                            [-0.4830746, 52.6413321],
                            [7.3062409, 51.5458031],
                            [9.9659855, 53.6125259],
                            [11.5923438, 48.159395],
                            [8.9891256, 52.8280051],
                            [7.0355606, 51.4356438],
                            [7.4654343, 51.4961111],
                            [9.7435783, 48.9339518],
                            [10.8123924, 54.1024418],
                            [8.5572261, 47.4122963],
                            [10.1952121, 53.6888482],
                            [9.8954232, 53.6156915],
                            [9.929928, 53.5554142],
                            [10.5308898, 53.8865199],
                            [9.4531594, 47.6409837],
                            [8.69492, 50.0295097],
                            [9.9766112, 53.5747274],
                            [8.69492, 50.0295097],
                            [7.3918716, 52.1512065],
                            [9.9908875, 53.5776266],
                            [10.2519749, 53.4911236],
                            [9.6991755, 53.5936117],
                            [6.7635076, 51.512382],
                            [9.9519685, 53.5795289],
                            [9.3761986, 48.8367616],
                            [13.3137619, 52.5087124],
                            [10.0119789, 53.5580847],
                            [8.2191927, 53.1015899],
                            [8.6161336, 47.3955306],
                            [9.0361189, 52.5184788],
                            [9.3651991, 47.4092997],
                            [9.5625866, 54.8383175],
                            [9.6991755, 53.5936117],
                            [9.9153055, 53.5566366],
                            [9.6991755, 53.5936117],
                            [7.9844554, 50.8803723],
                            [13.4072944, 52.5455109],
                            [9.2148545, 49.1423079],
                            [9.9999424, 53.59451],
                            [12.9107574, 47.7652689],
                            [13.4349237, 52.7191436],
                            [10.0807485, 53.5754959],
                            [9.9807553, 53.5552494],
                            [11.5286651, 48.0966922],
                            [9.7492444, 52.2466018],
                            [8.4095757, 49.0487963],
                            [10.0151198, 53.5730684],
                            [8.6738623, 50.0990675],
                            [10.199618, 53.5058423],
                            [9.1169914, 54.4688475],
                            [10.1693369, 53.5898122],
                            [9.9537512, 53.640901],
                            [11.2477637, 49.811649],
                            [11.1745224, 53.6527757],
                            [10.009959, 53.6088274],
                            [8.782397, 51.0800893],
                            [10.199618, 53.5058423],
                            [10.0061481, 53.5831749],
                            [10.0716475, 53.8405743],
                            [10.2260726, 53.489276],
                            [10.0119789, 53.5580847],
                            [12.3882958, 51.2012755],
                            [7.985781, 47.6736885],
                            [10.2353838, 53.6744402],
                            [8.2289979, 46.9038736],
                            [16.3502336, 48.1944991],
                            [8.5267528, 47.2003879],
                            [13.3147792, 52.4950243],
                            [6.7727077, 51.2220859],
                            [11.5819806, 48.1351253],
                            [8.506636, 49.4677562],
                            [7.1721227, 53.3647296],
                            [10.8371712, 51.4990777],
                            [8.7032376, 50.1616215],
                            [10.0056525, 53.4643986],
                            [8.4466485, 47.0738515],
                            [9.6632521, 53.7513549],
                            [6.8769987, 50.9984287],
                            [9.9908875, 53.5776266],
                            [9.9908875, 53.5776266],
                            [6.9513739, 51.3668596],
                            [9.9920811, 53.122449],
                            [13.2730408, 52.3899573],
                            [6.6518329, 51.3948213],
                            [10.4028748, 53.6111512],
                            [9.0856625, 49.9820397],
                            [10.4381381, 51.9113762],
                            [10.0119789, 53.5580847],
                            [8.1057681, 47.9055424],
                            [6.7825598, 51.2149435],
                            [9.9852574, 53.5316484],
                            [11.0780068, 53.5069254],
                            [10.1699453, 53.5422138],
                            [8.7270206, 53.5379727],
                            [9.5982175, 48.9758865],
                            [10.050543, 53.5602907],
                            [10.1501975, 54.2850224],
                            [13.3847539, 52.5155098],
                            [-6.232841, 53.3472385],
                            [9.8521093, 53.4554259],
                            [10.0437551, 53.5267106],
                            [9.74379, 47.4124],
                            [10.2625077, 53.7635437],
                            [9.9852574, 53.5316484],
                            [8.5350214, 49.9155479],
                            [13.3429021, 52.4972347],
                            [9.5067453, 53.2808449],
                            [10.1007586, 53.5683271],
                            [9.6828348, 53.4639095],
                            [11.5821606, 48.1447027],
                            [13.3032995, 52.5890862],
                            [13.3032995, 52.5890862],
                            [14.5140996, 35.8992375],
                            [10.0475077, 53.5673806],
                            [7.1636949, 51.9097477],
                            [9.5549856, 47.3700789],
                            [10.0986376, 53.588951],
                            [10.009959, 53.6088274],
                            [10.1387851, 53.5486838]
                        ];

                        // Define the markers with titles and descriptions in GeoJSON format
                        const geojson = {
                            type: 'FeatureCollection',
                            features: coordinates.map(coord => ({
                                type: 'Feature',
                                geometry: {
                                    type: 'Point',
                                    coordinates: coord
                                }
                            }))
                        };

                        // Add a new source from our GeoJSON data
                        map.addSource('markers', {
                            type: 'geojson',
                            data: geojson,
                            cluster: true,
                            clusterMaxZoom: 14, // Max zoom to cluster points on
                            clusterRadius: 45 // Radius of each cluster when clustering points
                        });

                        // Define the cluster circles
                        map.addLayer({
                            id: 'clusters',
                            type: 'circle',
                            source: 'markers',
                            filter: ['has', 'point_count'],
                            paint: {
                                'circle-color': ['step', ['get', 'point_count'], '#027CEC', 100, '#0078FF', 750, '#027CEC'],
                                'circle-radius': ['step', ['get', 'point_count'], 15, 100, 20, 750, 30],
                                'circle-stroke-width': 6,
                                'circle-stroke-color': 'rgba(0, 120, 255, 0.20)'
                            }
                        });

                        // Define the count labels
                        map.addLayer({
                            id: 'cluster-count',
                            type: 'symbol',
                            source: 'markers',
                            filter: ['has', 'point_count'],
                            layout: {
                                'text-field': '{point_count_abbreviated}',
                                'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
                                'text-size': 16
                            },
                            paint: {
                                'text-color': '#ffffff'
                            }
                        });

                        // Define the unclustered point markers
                        map.addLayer({
                            id: 'unclustered-point',
                            type: 'circle',
                            source: 'markers',
                            filter: ['!', ['has', 'point_count']],
                            paint: {
                                'circle-color': '#0040B8',
                                'circle-radius': 4,
                            }
                        });

                        // Listen for click events on clusters
                        map.on('click', 'clusters', function (e) {
                            const features = map.queryRenderedFeatures(e.point, {layers: ['clusters']});
                            const clusterId = features[0].properties.cluster_id;
                            map.getSource('markers').getClusterExpansionZoom(clusterId, function (err, zoom) {
                                if (err) return;

                                map.easeTo({
                                    center: features[0].geometry.coordinates,
                                    zoom: zoom
                                });
                            });
                        });

                        // Add cursor style
                        map.on('mouseenter', 'clusters', function () {
                            map.getCanvas().style.cursor = 'pointer';
                        });
                        map.on('mouseleave', 'clusters', function () {
                            map.getCanvas().style.cursor = '';
                        });
                    })

                    observer.unobserve(entry.target);
                });
            }
        }, this.options);
        io.observe(this.mapContainer);
    }
})



